import type { IFetchService } from "app/services/fetchService";

import { createAppsColumnConfigApiService } from "./columnConfigApiService";

export const createAppsSearchApiService = (fetchService: IFetchService) => {
    return {
        columnConfig: createAppsColumnConfigApiService(fetchService),
    };
};
